import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// Slim banner shown during a free trial: "N days left — Upgrade". Hidden for paid
// schools and the platform SuperAdmin (no school context → endpoint returns null).
const TrialBanner = () => {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let live = true;
    axios
      .get("/api/billing/status")
      .then((r) => { if (live) setStatus(r.data?.data || null); })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  if (!status || status.status !== "trialing" || status.daysLeft == null || status.blocked) return null;

  const d = status.daysLeft;
  const urgent = d <= 3;
  return (
    <div
      role="status"
      style={{
        display: "flex", alignItems: "center", justifyContent: "center", gap: 12, flexWrap: "wrap",
        padding: "8px 16px", fontSize: 14,
        background: urgent ? "#fff4e5" : "#eef4ff",
        color: urgent ? "#8a4b00" : "#1e3a8a",
        borderBottom: `1px solid ${urgent ? "#ffd8a8" : "#c7d7fe"}`,
      }}
    >
      <span>
        {d <= 0 ? "Your free trial ends today." : `${d} day${d === 1 ? "" : "s"} left in your free trial`}
        {status.plan?.name ? ` (${status.plan.name} plan)` : ""}.
      </span>
      <button
        type="button"
        onClick={() => navigate("/billing")}
        style={{
          border: 0, borderRadius: 6, padding: "4px 12px", cursor: "pointer", fontWeight: 600,
          background: urgent ? "#d9480f" : "#2563eb", color: "#fff",
        }}
      >
        Upgrade
      </button>
    </div>
  );
};

export default TrialBanner;
